var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconVertAlignCenter24Line = function SvgIconVertAlignCenter24Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11.15h-13v1.7h13v-1.7ZM12 14.44c-.365 0-.725.155-.975.42L8.42 17.595l1.085 1.035 1.645-1.73v3.635h1.7V16.9l1.645 1.73 1.085-1.035-2.605-2.735a1.363 1.363 0 0 0-.975-.42ZM12 9.56c.365 0 .725-.15.98-.42l2.605-2.735L14.5 5.37 12.855 7.1V3.465h-1.7V7.1L9.51 5.37 8.425 6.405 11.03 9.14c.255.265.61.42.975.42H12Z"
  }))));
};
export default SvgIconVertAlignCenter24Line;